import * as ng from 'angular';
import * as ui from 'angular-ui-bootstrap';

const fieldSelectView = require('./field-select-modal.html');

// https://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
function escapeRegExp(str) {
   return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}

ng.module('e360').run(registerFieldPlugin);

registerFieldPlugin.$inject = ['$uibModal'];
export function registerFieldPlugin($uibModal:ui.IModalService) {
   let tinymce = window['tinymce'];
   tinymce.PluginManager.add('fields', fieldPluginFactory);

   function fieldPluginFactory(editor, url) {
      editor.addButton('addField', {
         tooltip: 'Add Field',
         icon: 'browse',
         onclick: addFieldHandler
      });

      // this is less than ideal since it overrides any values alreadyin
      // tinymce options, but atm we aren't using them elsewhere
      editor.settings.custom_elements = '~field';
      editor.settings.extended_valid_elements = 'field[*]';

      editor.contentStyles.push(
         'field { border-bottom: 1px dashed blue; }'
      );

      var fieldPrefix = editor.settings.field_prefix;
      var fieldSuffix = editor.settings.field_suffix;
      var preExp = new RegExp(escapeRegExp(fieldPrefix), 'g');
      var sufExp = new RegExp(escapeRegExp(fieldSuffix), 'g');

      editor.on('BeforeSetContent', function (e) {
         e.content = e.content
            .replace(preExp, '<field class="mceNonEditable">')
            .replace(sufExp, '</field>');
      });

      editor.on('GetContent', function (e) {
         e.content = e.content
            .replace(/<field class="mceNonEditable">/g, fieldPrefix)
            .replace(/<\/field>/g, fieldSuffix);
      });

      function addFieldHandler() {
         // save current selection before opening modal
         let rng = editor.selection.getRng();

         $uibModal.open({
            templateUrl: fieldSelectView,
            controller: FieldModalController,
            controllerAs: '$ctrl',
            resolve: {
               fields: () => editor.settings.fields
            }
         }).result.then(function (fieldKey) {
            // modal causes inline editor to loose previous cursor position
            editor.selection.setRng(rng);

            editor.insertContent(`<field class="mceNonEditable">${fieldKey}</field>`);
         });
      }
   }
}

class FieldModalController {
   static $inject = ['$uibModalInstance', 'fields'];

   constructor(private $uibModalInstance, public fields) { }

   ok(fieldKey) {
      if (fieldKey) {
         this.$uibModalInstance.close(fieldKey);
      }
   }

   cancel() {
      this.$uibModalInstance.dismiss('cancel');
   }
}
